import lub2122Altf1Img from "../../../images/camisetas/LUB21-22ALTF-1.webp";
import lub2122Altf2Img from "../../../images/camisetas/LUB21-22ALTF-2.webp";
import lub2122Rvf1Img from "../../../images/camisetas/LUB21-22RVF-1.webp";
import lub2122Rvf2Img from "../../../images/camisetas/LUB21-22RVF-2.webp";
import lub2122Rvf3Img from "../../../images/camisetas/LUB21-22RVF-3.webp";
import lub2223AltfImg from "../../../images/camisetas/LUB22-23ALTF.webp";
import lub2223RvfImg from "../../../images/camisetas/LUB22-23RVF.webp";
import lub2324AltfImg from "../../../images/camisetas/LUB23-24ALTF.webp";
import lub2324RvfImg from "../../../images/camisetas/LUB23-24RVF.webp";
import lub2425AltfImg from "../../../images/camisetas/LUB24-25ALTF.webp";
import lub2425RvfImg from "../../../images/camisetas/LUB24-25RVF.webp";
import lub2526AltfImg from "../../../images/camisetas/LUB25-26ALTF.webp";
import lub2526RvfImg from "../../../images/camisetas/LUB25-26RVF.webp";
import lub21AltfImg from "../../../images/camisetas/LUB21ALTF.webp";
import lub21RvfImg from "../../../images/camisetas/LUB21RVF.webp";
import lub1920AltfImg from "../../../images/camisetas/LUB19-20ALTF.webp";
import lub1920RvfImg from "../../../images/camisetas/LUB19-20RVF.webp";
import lub1819AltfImg from "../../../images/camisetas/LUB18-19ALTF.webp";
import lub1819RvfImg from "../../../images/camisetas/LUB18-19RVF.webp";
import lub1718AltfImg from "../../../images/camisetas/LUB17-18ALTF.webp";
import lub1718RvfImg from "../../../images/camisetas/LUB17-18RVF.webp";
import lub1617AltfImg from "../../../images/camisetas/LUB16-17ALTF.webp";
import lub1617RvfImg from "../../../images/camisetas/LUB16-17RVF.webp";
import lub1516AltfImg from "../../../images/camisetas/LUB15-16ALTF.webp";
import lub1516RvfImg from "../../../images/camisetas/LUB15-16RVF.webp";
import lub1415AltfImg from "../../../images/camisetas/LUB14-15ALTF.webp";
import lub1415RvfImg from "../../../images/camisetas/LUB14-15RVF.webp";
import lub1314AltfImg from "../../../images/camisetas/LUB13-14ALTF.webp";
import lub1314RvfImg from "../../../images/camisetas/LUB13-14RVF.webp";
import lub1213AltfImg from "../../../images/camisetas/LUB12-13ALTF.webp";
import lub1213RvfImg from "../../../images/camisetas/LUB12-13RVF.webp";

const rojiverdeTitles = [
    "LUB 2025/26",
    "LUB 2024/25",
    "LUB 2023/24",
    "LUB 2022/23",
    "LUB 2021/22",
    "LUB 2021",
    "LUB 2019/20",
    "LUB 2018/19",
    "LUB 2017/18",
    "LUB 2016/17",
    "LUB 2015/16",
    "LUB 2014/15",
    "LUB 2013/14",
    "LUB 2012/13",
];

const DEFAULT_BRAND = "Puma";

const brandBySeason = {
    "LUB 2025/26": {
        rojiverde: "Puma",
        alternativa: "Puma",
    },
    "LUB 2024/25": {
        rojiverde: "Puma",
        alternativa: "Puma",
    },
    "LUB 2023/24": {
        rojiverde: "Puma",
        alternativa: "Puma",
    },
    "LUB 2022/23": {
        rojiverde: "Puma",
        alternativa: "Puma",
    },
    "LUB 2021/22": {
        rojiverde: ["Puma", "Puma", "Podium"],
        alternativa: ["Puma", "Podium"],
    },
    "LUB 2021": {
        rojiverde: "Peak",
        alternativa: "Peak",
    },
    "LUB 2019/20": {
        rojiverde: "Peak",
        alternativa: "Peak",
    },
    "LUB 2018/19": {
        rojiverde: "Peak",
        alternativa: "Peak",
    },
    "LUB 2017/18": {
        rojiverde: "Luanvi",
        alternativa: "Luanvi",
    },
    "LUB 2016/17": {
        rojiverde: "Joma",
        alternativa: "Joma",
    },
    "LUB 2015/16": {
        rojiverde: "Joma",
        alternativa: "Joma",
    },
    "LUB 2014/15": {
        rojiverde: "A'S",
        alternativa: "A'S",
    },
    "LUB 2013/14": {
        rojiverde: "A'S",
        alternativa: "A'S",
    },
    "LUB 2012/13": {
        rojiverde: "Fit",
        alternativa: "Fit",
    },
};

function getSpecialImages(variant, title) {
    if (title === "LUB 2025/26") {
        return [variant === "alternativa" ? lub2526AltfImg : lub2526RvfImg];
    }

    if (title === "LUB 2024/25") {
        return [variant === "alternativa" ? lub2425AltfImg : lub2425RvfImg];
    }

    if (title === "LUB 2023/24") {
        return [variant === "alternativa" ? lub2324AltfImg : lub2324RvfImg];
    }

    if (title === "LUB 2022/23") {
        return [variant === "alternativa" ? lub2223AltfImg : lub2223RvfImg];
    }

    if (title === "LUB 2021/22") {
        return variant === "alternativa"
            ? [lub2122Altf2Img, lub2122Altf1Img]
            : [lub2122Rvf3Img, lub2122Rvf2Img, lub2122Rvf1Img];
    }

    if (title === "LUB 2021") {
        return [variant === "alternativa" ? lub21AltfImg : lub21RvfImg];
    }

    if (title === "LUB 2019/20") {
        return [variant === "alternativa" ? lub1920AltfImg : lub1920RvfImg];
    }

    if (title === "LUB 2018/19") {
        return [variant === "alternativa" ? lub1819AltfImg : lub1819RvfImg];
    }

    if (title === "LUB 2017/18") {
        return [variant === "alternativa" ? lub1718AltfImg : lub1718RvfImg];
    }

    if (title === "LUB 2016/17") {
        return [variant === "alternativa" ? lub1617AltfImg : lub1617RvfImg];
    }

    if (title === "LUB 2015/16") {
        return [variant === "alternativa" ? lub1516AltfImg : lub1516RvfImg];
    }

    if (title === "LUB 2014/15") {
        return [variant === "alternativa" ? lub1415AltfImg : lub1415RvfImg];
    }

    if (title === "LUB 2013/14") {
        return [variant === "alternativa" ? lub1314AltfImg : lub1314RvfImg];
    }

    if (title === "LUB 2012/13") {
        return [variant === "alternativa" ? lub1213AltfImg : lub1213RvfImg];
    }

    return null;
}

function getBrand(variant, title, editionIndex) {
    const seasonBrands = brandBySeason[title];
    if (!seasonBrands) {
        return DEFAULT_BRAND;
    }

    const variantBrand = seasonBrands[variant];
    if (!variantBrand) {
        return DEFAULT_BRAND;
    }

    if (Array.isArray(variantBrand)) {
        return variantBrand[editionIndex] ?? variantBrand[0] ?? DEFAULT_BRAND;
    }

    return variantBrand;
}

function buildCamisetas(variant, titles) {
    return titles.flatMap((title, index) => {
        const images = getSpecialImages(variant, title) ?? [];

        return images.map((image, editionIndex) => ({
            id: `${variant}-${index + 1}-${editionIndex + 1}`,
            variant,
            title,
            brand: getBrand(variant, title, editionIndex),
            image,
        }));
    });
}

const camisetasByMode = {
    rojiverde: buildCamisetas("rojiverde", rojiverdeTitles),
    alternativa: buildCamisetas("alternativa", rojiverdeTitles),
};

function useCamisetasData(mode = "rojiverde") {
    return camisetasByMode[mode] ?? camisetasByMode.rojiverde;
}

export default useCamisetasData;
